import React from 'react';
import moment from 'moment';
import { render } from 'react-dom';
import Feedback from '../../../components/popups/Feedback';
import Certification from '../../../components/popups/Certification';
import routes from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
import InfoPopup from '../../../components/popups/InfoPopup';
import metrikaGoal from '../../../helpers/metrikaGoal';

const statuses = {
  notStarted: 'not_started', // course status
  inProgress: 'in_progress', // course status
  pending: 'pending',
  complete: 'complete', // course status
  passed: 'passed',
  accepted: 'accepted',
  incomplete: 'incomplete',
  failed: 'failed',
  declined: 'declined',
};

class ISpringTab extends React.PureComponent {
  // state = {
  //   courses: [
  //     {
  //       id: 'twoCourse',
  //       header: 'Курс по оказанию психологической помощи',
  //       info: 'Данный курс мы прошли на 100 процентов',
  //       hint: 'Вы зарегистрировались 12\u00A0января\u00A02021',
  //       ctaDescription: 'Завершен 12 февраля 2021',
  //       status: statuses.complete,
  //       progress: 100,
  //       rfId: '1f44bf6b-8396-na11-b80f-006056bb866d',
  //       reviewed: true,
  //       certification: true,
  //     },
  //     {
  //       id: 'oneCourse',
  //       header: 'Курс по программированию под macOS',
  //       info: 'Данный курс мы еще не прошли на 100%, но нам его уже завершили',
  //       hint: 'Вы зарегистрировались 16\u00A0марта\u00A02021',
  //       ctaDescription: 'Завершен 20 марта 2021',
  //       status: statuses.complete,
  //       progress: 55,
  //       rfId: '1f44bf6b-3396-ea11-p80f-005056bb866d',
  //       reviewed: false,
  //       certification: true,
  //     },
  //     {
  //       id: 'threeCourse',
  //       header: 'Курс по управлению астральными снами',
  //       info: 'Данный курс мы еще проходим',
  //       hint: 'Вы зарегистрировались 22\u00A0апреля\u00A02021',
  //       ctaDescription: 'Завершить до 3 мая 2021',
  //       status: statuses.inProgress,
  //       progress: 13,
  //       reviewed: false,
  //       certification: false,
  //     },
  //     {
  //       id: 'fourCourse',
  //       header: 'Курс по написание интересных статей',
  //       info: 'Данный курс мы еще не начали проходить',
  //       hint: 'Вы зарегистрировались 1\u00A0мая\u00A02021',
  //       ctaDescription: 'Начать до 31 мая 2021',
  //       status: statuses.notStarted,
  //       reviewed: false,
  //       certification: false,
  //     },
  //     {
  //       id: 'fiveCourse',
  //       header: 'Курс по краткости',
  //       hint: 'Вы зарегистрировались 10\u00A0мая\u00A02021',
  //       ctaDescription: 'Начать до 10 июня 2021',
  //       status: statuses.notStarted,
  //       reviewed: false,
  //       certification: false,
  //     },
  //   ],
  //   showCertBlocks: false,
  //   spinnerState: spinnerStates.done,
  // };
  constructor(props) {
    super(props);
    this.state = {
      courses: this.getISpringData(),
      showCertBlocks: false,
      spinnerState: 'done',
    };
  }

  /**
   *
   * @param momentDate date as moment object
   * @return {string}
   */
  getDueToString = momentDate => {
    if (!momentDate.isValid()) return '';
    if (momentDate.valueOf() < Date.now()) return 'Доступ закрыт';

    return `Доступен до ${momentDate.format('DD\u00A0MMMM\u00A0YYYY')}`;
  };

  getISpringData = () => {
    const data = window?.user?.ISPRING_REGISTRATION_FORMS?.map(course => {
      const addedDateRaw = moment(
        course.RESULT?.ACCESS_DATE,
        'DD.MM.YYYY HH:mm:ss',
      );

      const addedDateStr = addedDateRaw.isValid()
        ? `Вы зарегистрировались ${addedDateRaw.format(
            'DD\u00A0MMMM\u00A0YYYY',
          )}`
        : '';

      const dueDateRaw = moment(course.RESULT?.DUE_DATE, 'DD.MM.YYYY HH:mm:ss');
      const dueDateStr = this.getDueToString(dueDateRaw);

      return {
        header: course?.COURSE?.TITLE,
        info: course?.COURSE?.DESCRIPTION,
        hint: addedDateStr,
        ctaDescription: dueDateStr,
        progress: Number(course?.RESULT?.PROGRESS),
        remaining: 100 - Number(course?.RESULT?.PROGRESS),
        status: course?.RESULT?.COMPLETION_STATUS,
        link: course?.COURSE?.ISPRING_AUTH,
        id: course?.RESULT?.ID,
        rfId: course?.RF_ID,
        reviewed: course?.REVIEWED,
        certification: course?.CERTIFICATION,
      };
    });

    return data || [];
  };

  renderEmptyPlaceholder = () => {
    return <div>Здесь будут отображаться курсы iSpring</div>;
  };

  getProgressStatusText = courseData => {
    switch (courseData.status) {
      case statuses.notStarted:
        return (
          <span className="ispring-cta__progress--not-started">Не начат</span>
        );
      case statuses.inProgress:
        return <span>Осталось {100 - courseData.progress}%</span>;
      case statuses.complete:
        return (
          <span className="ispring-cta__progress--is-complete">{courseData.progress === 100 ? 'Пройден 100%' : `${courseData.progress}%`}</span>
        );
      default:
        return <span className="ispring-cta__progress--not-started" />;
    }
  };

  showFeedbackModal = (e) => {
    metrikaGoal('reviewOpen');
    const {id} = e.currentTarget.dataset;
    const activeCourseData = this.state.courses.find((course) => course.id === id);

    const closeInfoPopup = () => $.magnificPopup.proto.close.call(this);

    const showCertificationBlocks = () => {
      $.magnificPopup.proto.close.call(this);

      setTimeout(() => {
        metrikaGoal('reviewSend');
        this.setState({showCertBlocks: true});
        $.magnificPopup.open({
          removalDelay: 250,
          mainClass: 'mfp-anim',
          closeOnBgClick: false,
          items: {
            src: $('#popup'),
            type: 'inline',
          },
          callbacks: {
            open() {
              document.body.style.overflow = 'hidden';
              render(
                <InfoPopup
                  title="Спасибо, что оставили отзыв!"
                  text="Теперь вам доступен промокод на новые программы и сертификат об окончании обучения."
                  buttonText="Понятно"
                  buttonCallback={closeInfoPopup}
                />,
                $('#popup')[0]
              );
            },
            close() {
              document.body.style.overflow = '';
              render(<div />, $('#popup')[0]);
            },
          },
        });
      }, 500);
    };

    $.magnificPopup.open({
      removalDelay: 250,
      mainClass: 'mfp-anim',
      closeOnBgClick: false,
      items: {
        src: $('#popup'),
        type: 'inline',
      },
      callbacks: {
        open() {
          document.body.style.overflow = 'hidden';
          render(<Feedback courseData={activeCourseData} onResultCallback={showCertificationBlocks} />, $('#popup')[0]);
        },
        close() {
          document.body.style.overflow = '';
          render(<div />, $('#popup')[0]);
        },
      },
    });
  };

  showCertificationModal = (e) => {
    metrikaGoal('sertOpen');
    const {id} = e.currentTarget.dataset;
    const activeCourseData = this.state.courses.find((course) => course.id === id);

    const onClosePopup = () => $.magnificPopup.proto.close.call(this);

    const openCertificationModal = ({certData, error}) => {
     $.magnificPopup.open({
        removalDelay: 250,
        mainClass: 'mfp-anim',
        closeOnBgClick: false,
        items: {
          src: $('#popup'),
          type: 'inline',
        },
        callbacks: {
          open() {
            document.body.style.overflow = 'hidden';
            render(
              <Certification
                onCloseCallback={onClosePopup}
                certData={{courseTitle: activeCourseData.header, ...certData}}
                error={error}
              />,
              $('#popup')[0]
            );
          },
          close() {
            document.body.style.overflow = '';
            render(<div />, $('#popup')[0]);
          },
        },
      });
    };

    const url = `${routes.user.certificate}/${activeCourseData.rfId}`;
    const options = {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
      },
      credentials: 'include',
    };

    this.setState({spinnerState: spinnerStates.pending});

    fetch(url, options)
      .then(response => response.json())
      .then(({status, data, errors}) => {
        switch (status) {
        case 'success':
          openCertificationModal({certData: data});
          break;
        case 'error':
          openCertificationModal({error: errors[0].message});
          break;
        default:
          openCertificationModal({error: messages.unknownError});
        }
        this.setState({spinnerState: spinnerStates.done});
      })
      .catch(() => {
        this.setState({spinnerState: spinnerStates.done});
        openCertificationModal({error: messages.serverTimeout});
      });
  };

  renderISpringCard = (courseData, index) => {
    const progressClasses = ['ispring-cta__progress'];
    const progressText = this.getProgressStatusText(courseData);
    const {reviewed, certification} = courseData;

    return (
      <div
        className="ispring__container"
        key={`course_${courseData.header}_${index}`}
      >
        {(certification && (reviewed || this.state.showCertBlocks)) && (
          <div className="ispring-info-block">
            <div className="ispring-info-block__icon ispring-info-block__icon--check" />
            <div className="ispring-info-block__text">Ваш промокод: <b>PWCELEARNING2021</b> (скидка 15% на все онлайн-курсы Академии PwC)</div>
            <div className="ispring-info-block__button">
              <button
                type="button"
                className="btn btn--primary"
                data-id={courseData.id}
                onClick={this.showCertificationModal}
              >
                {this.state.spinnerState === spinnerStates.done ? (
                  "Сертификат"
                ) : (
                  <>
                    <span className="invisible">Сертификат</span>
                    <Loader
                      spinnerState={this.state.spinnerState}
                      spinnerPosition={spinnerPositions.absolute}
                      className="loader--white"
                    />
                  </>
                )}
              </button>
            </div>
          </div>
        )}
        {(certification && !reviewed && !this.state.showCertBlocks)  && (
          <div className="ispring-info-block">
            <div className="ispring-info-block__icon ispring-info-block__icon--exclamation" />
            <div className="ispring-info-block__text">Пожалуйста, оставьте отзыв для получения сертификата. </div>
            <div className="ispring-info-block__button">
              <button
                type="button"
                className="btn btn--primary"
                data-id={courseData.id}
                onClick={this.showFeedbackModal}
              >
                Оставить{'\u00A0'}отзыв
              </button>
            </div>
          </div>
        )}
        <div className="ispring-content">
          <div className="ispring-info__container">
            <div className="ispring-info__header">{courseData.header}</div>
            <div className="ispring-info__content">{courseData.info}</div>
          </div>
          <div className="ispring-hint">{courseData.hint}</div>
        </div>
        <div className="ispring-cta__container">
          {(!reviewed && !certification) && (
            <div className="ispring-cta__button">
              <a className="btn btn--outline" href={courseData.link}>
                Перейти{'\u00A0'}к{'\u00A0'}курсу
              </a>
            </div>
          )}
          <div className="ispring-cta__description">
            {courseData.ctaDescription}
          </div>
          <div className={progressClasses.join(' ')}>{progressText}</div>
        </div>
        {courseData.progress > 0 && (
          <div className="ispring-bar__container">
            <div
              className="ispring-bar__status"
              style={{ width: `${courseData.progress}%` }}
            />
          </div>
        )}
      </div>
    );
  };

  // card without info
  renderISpringCardNI = (courseData, index) => {
    const progressClasses = ['ispring-cta__progress'];
    const progressText = this.getProgressStatusText(courseData);
    return (
      <div
        className="ispring__container"
        key={`course_${courseData.header}_${index}`}
      >
        <div className="ispring-content ">
          <div className="ispring-info__container ispring-info__container--ni">
            <div className="ispring-info__header">{courseData.header}</div>
            <div className="ispring-hint ispring-hint--ni">
              {courseData.hint}
            </div>
          </div>
          <div
            className={`${progressClasses.join(' ')} ispring-cta__progress--ni`}
          >
            {progressText}
          </div>
        </div>

        <div className="ispring-cta__container">
          <div className="ispring-cta__description">
            {courseData.ctaDescription}
          </div>
          <div className="ispring-cta__button ispring-cta__button--ni">
            <a className="btn btn--outline" href={courseData.link}>
              Перейти{'\u00A0'}к{'\u00A0'}курсу
            </a>
          </div>
          <div
            className={
              `${progressClasses.join(' ')} ispring-cta__progress--ni-mobile`
            }
          >
            {progressText}
          </div>
        </div>

        {courseData.progress > 0 && courseData.status === statuses.inProgress && (
          <div className="ispring-bar__container">
            <div
              className="ispring-bar__status"
              style={{ width: `${courseData.progress}%` }}
            />
          </div>
        )}
      </div>
    );
  };

  renderISpringCardPending = (courseData, index) => {
    return (
      <div
        className="ispring__container"
        key={`course_${courseData.header}_${index}`}
      >
        <div className="ispring-content ">
          <div className="ispring-info__container ispring-info__container--ni">
            <div className="ispring-info__header">{courseData.header}</div>
          </div>
        </div>

        <div className="ispring-cta__container">
          <div
            className="ispring-hint ispring-hint--ni"
            // style={{ fontWeight: 'normal' }}
          >
            Информация о курсе будет доступна в течение 5 минут
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { courses } = this.state;
    if (!courses.length) return this.renderEmptyPlaceholder();
    return courses.map((course, index) => {
      if (!course.id) return this.renderISpringCardPending(course, index);
      if (!course.info) return this.renderISpringCardNI(course, index);
      return this.renderISpringCard(course, index);
    });
  }
}

export default ISpringTab;
